import Common from '../utils/common.util';
import Vue from 'vue';


const BASE_URL = `${process.env.VUE_APP_API_ROOT}/players`;

// tslint:disable-next-line:variable-name
const PLAYER_SERVICE = {
	playerById: function (playerId: string) {
		Vue.$log.debug(`loading player ${playerId}`);
		return Vue.http.get(`${BASE_URL}/${playerId}`);
	},
	playerPictures: function (playerId: string) {
		Vue.$log.debug(`loading pictures of player ${playerId}`);
		return Vue.http.get(Common.links.playerPictures(playerId));
	}
};

export default PLAYER_SERVICE;
